// extracted by mini-css-extract-plugin
export default {"loading":"SpinnerBlock_loading__f3J9A","title":"SpinnerBlock_title__urQBI","info":"SpinnerBlock_info__aBOKM","spinner":"SpinnerBlock_spinner__avCTY"};